import react from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import Contact from "./contact";

export default function Access() {
  return (
    <div className="cnt-4" id="access">
      <div className="access-title">Access</div>
      <div className="access-wrapper">
        <div className="adress-text">
          <ul className="access-ul">
            <li className="access-label">
              <p className="access-li">会社名</p>
            </li>
            <li>
              <p>株式会社リオネス</p>
            </li>
          </ul>
          <ul className="access-ul">
            <li className="access-label">
              <p className="access-li">住所</p>
            </li>
            <li>
              <p>
                〒150-0022
                <br />
                東京都渋谷区恵比寿南2-8-2　キョウデンビル7階
                <div className="map-link">
                  <a
                    href="https://www.google.co.jp/maps/place/%E3%80%92150-0022+%E6%9D%B1%E4%BA%AC%E9%83%BD%E6%B8%8B%E8%B0%B7%E5%8C%BA%E6%81%B5%E6%AF%94%E5%AF%BF%E5%8D%97%EF%BC%92%E4%B8%81%E7%9B%AE%EF%BC%98%E2%88%92%EF%BC%92/@35.6445331,139.7066545,17z/data=!3m1!4b1!4m5!3m4!1s0x60188b3f7e2f886f:0x1435f3a60e482e15!8m2!3d35.6445288!4d139.7088432?hl=ja"
                    alt=""
                    target="_blank"
                  >
                    Google MAPへ↗︎
                    <img
                      src="../images/arrow-up.svg"
                      className="arrow-up-icon"
                      alt=""
                    />
                  </a>
                </div>
              </p>
            </li>
          </ul>
          <ul className="access-ul">
            <li className="access-label">
              <p className="access-li">電話番号</p>
            </li>
            <li>
              <p>03-6412-7717</p>
            </li>
          </ul>
          <ul className="access-ul">
            <li className="access-label">
              <p className="access-li">FAX番号</p>
            </li>
            <li>
              <p>03-6412-7914</p>
            </li>
          </ul>
          <ul className="access-ul">
            <li className="access-label">
              <p className="access-li">事業内容</p>
            </li>
            <li>
              <p>
                ドラマ・映画の企画・制作、その他映像作品の企画・制作、不動産事業、健康事業
              </p>
            </li>
          </ul>
          <br />
          <ul className="access-ul">
            <li className="access-label">
              <p className="access-li" id="contact">
                問い合わせ
              </p>
            </li>
            <li>
              <Contact />
            </li>
          </ul>
        </div>
        {/* <div className="googleMap">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.3181196187443!2d139.70665451519963!3d35.64453313959128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b3f7e2f886f%3A0x1435f3a60e482e15!2z44CSMTUwLTAwMjIg5p2x5Lqs6YO95riL6LC35Yy65oG15q-U5a-_5Y2X77yS5LiB55uu77yY4oiS77yS!5e0!3m2!1sja!2sjp!4v1658851974919!5m2!1sja!2sjp"
            width="400"
            height="300"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div> */}
      </div>
    </div>
  );
}
